// src/i18n/fr.ts
export const fr = {
  landing: {
    verifying: "Vérification de l'invitation...",
    invalidTitle: "Invitation invalide",
    validTitle: "Invitation valide",
    typeFace: "Enregistrement Facial",
    typeAccount: "Création de Compte",
    expires: "Expire :",
    start: "Commencer",
  },
  identity: {
    step: "Étape 1 sur 2",
    title: "Vérification d'identité",
    subtitle: "Saisissez les données exactes de votre document.",
    country: "Pays",
    countryPlaceholder: "Sélectionner...",
    idType: "Type de document",
    idTypePlaceholder: "Sélectionner...",
    number: "Numéro",
    numberPlaceholder: "Ex : 12345678",
    verify: "Vérifier l'identité",
    verifying: "Vérification...",
  },
  enroll: {
    title: "Enregistrement facial",
    completed: "terminées",
    of: "sur",
    completionTitle: "Enregistrement terminé !",
    completionMessage: "Voulez-vous finaliser l'enregistrement ou modifier une image ?",
    finish: "Terminer",
    modify: "Modifier",
    positionStart: "Commencer",
    infoTitle: "Préparez votre environnement",
    infoSubtitle: "Pour obtenir les meilleures photos, suivez ces recommandations :",
    infoStand: "Tenez-vous face à la caméra à une distance de 30-50 cm.",
    infoBackground: "Utilisez un fond blanc ou de couleur neutre.",
    infoLook: "Regardez fixement la caméra sans lunettes de soleil ni casquette.",
    infoLight: "Assurez-vous d'avoir un bon éclairage frontal.",
    infoStart: "Commencer l'enregistrement",
    positions: {
      FRONT: { name: "Face", hint: "Regardez droit vers la caméra", instruction: "Regardez droit vers la caméra en gardant la tête immobile" },
      UP: { name: "Haut", hint: "Inclinez légèrement la tête vers le haut", instruction: "Inclinez légèrement la tête vers le haut" },
      DOWN: { name: "Bas", hint: "Inclinez légèrement la tête vers le bas", instruction: "Inclinez légèrement la tête vers le bas" },
      LEFT: { name: "Gauche", hint: "Tournez légèrement la tête à gauche", instruction: "Tournez légèrement la tête à gauche" },
      RIGHT: { name: "Droite", hint: "Tournez légèrement la tête à droite", instruction: "Tournez légèrement la tête à droite" },
    },
  },
  camera: {
    noFace: "Rapprochez votre visage de la caméra",
    notCentered: "Centrez votre visage dans le cadre",
    wrongPose: "Ajustez la position de votre tête",
    blink: "Clignez une fois",
    holdPose: "Maintenez la pose...",
    perfect: "Parfait ! Capture...",
    usePhoto: "Utiliser cette photo ?",
    retake: "Reprendre",
    confirm: "Utiliser",
    uploading: "Envoi de la photo...",
    retryUpload: "Réessayer l'envoi",
    cameraError: "Problème de caméra",
    retry: "Réessayer",
  },
  liveness: {
    face: "Visage détecté",
    centered: "Centré",
    pose: "Position correcte",
    blink: "Clignement",
    hold: "Maintenir",
  },
  account: {
    step: 'Étape 2 sur 2',
    title: 'Créez votre mot de passe',
    subtitle: 'Définissez le mot de passe de votre compte. Vous pourrez ensuite vous connecter avec votre document ou votre email.',
    password: 'Mot de passe',
    passwordPlaceholder: '8 caractères minimum',
    confirm: 'Confirmer le mot de passe',
    confirmPlaceholder: 'Répétez votre mot de passe',
    email: 'Email (optionnel)',
    emailPlaceholder: 'vous@email.com',
    emailHint: 'Il vous servira pour vous connecter et recevoir des notifications.',
    mismatch: 'Les mots de passe ne correspondent pas',
    tooShort: 'Le mot de passe doit contenir au moins 4 caractères',
    invalidEmail: "Format d'email invalide",
    submit: 'Activer le compte',
    submitting: 'Activation...',
  },
  summary: {
    title: "Enregistrement terminé !",
    subtitle: "Votre visage a été enregistré avec succès.",
    titleAccount: 'Compte activé !',
    subtitleAccount: 'Votre mot de passe a été enregistré. Vous pouvez maintenant vous connecter à la plateforme.',
    finish: "Terminer",
  },
  errors: {
    invalidInvitation: "Invitation invalide",
    verifyIdentity: "Erreur de vérification d'identité",
    activateAccount: "Erreur d'activation du compte",
    missingContext: "Contexte d'enregistrement manquant",
  },
} as const